import { render } from "./DashboardKol.vue?vue&type=template&id=5dd4516b"
import script from "./DashboardKol.vue?vue&type=script&lang=js"
export * from "./DashboardKol.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__